<template>
  <div class="grade">
    <div class="text">
      CR评级，是从企业的规模、企业背景、行业展望、财务状况等几大维度，根据各种反应企业综合状况及信用表现的指标，对企业进行信用迎分和预授信，可帮助金融机构更快、更精确的为您提供金融服务，帮助金融机构提升融资效率。
    </div>
    <div class="buttonList">
      <div class="button" @click="gotoPage">我要评分</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    gotoPage() {
      this.$router.push({
        path: 'score',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.grade {
  height: 100%;
  background: white;
  border-radius: 16px;
  padding: 10px;
  .text {
    text-indent: 2rem;
    line-height: 40px;
    // font-size: 16px;
    font-weight: bold;
  }
  .buttonList {
    display: block;
    text-align: center;
    margin-top: 200px;
  }
  .button {
    display: inline-block;
    margin-bottom: 10px;
    border: 1px solid #1366ec;
    padding: 10px 25px;
    border-radius: 5px;
    color: #fff;
    background: #1366ec;
    cursor: pointer;
  }
}
</style>